<div class="header">
  <h1>{{data.title}}</h1>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <iframe [src]="iframeSource"></iframe>
</mat-dialog-content>